import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { EmbryoService } from "src/app/Services/Embryo.service";
// import { environmentVariables } from '../../../environments/enviromentalVariables';
import { SwiperConfigInterface } from "ngx-swiper-wrapper";

import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { HomePageService } from "src/app/Services/home-page.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
@Component({
    selector: "app-categories",
    templateUrl: "./categories.component.html",
    styleUrls: ["./categories.component.scss"],
})
export class CategoriesComponent implements OnInit, AfterViewInit , OnChanges {
 public config: SwiperConfigInterface = {};
    brandsList: any;
    CateSwiperConfig: any = {};
    environmentVariables: any;
    lang: any;
    routerSubscription: any;
    allCategories: any[] = [];
    arrayList: any[] = [];
    loading: boolean = true;
    headerName: any;
    selectedCategory: any;
    selectedGroup: any;
    fakeArray = new Array(8);
    firstTimeLoaded = true;
    categoriesPage = false;
    showbreadCrumb = false
    allFeaturedCategories:any[] = [];
    nameRouting: any = [];
    @Input() isSlider : any =  null;
      categoryTypeData = {
       isSlider:'',
       isSqure:'',
    };
    constructor(
        public embryoService: EmbryoService,
        private translate: TranslateService,
        private router: Router,
        private homeData: HomePageService,
        private confgServ: StaticPagesService,
    ) {
        this.getInitilizingData();
        embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
            if (!this.firstTimeLoaded) {
                this.getCategories();
            }
        });

        this.routerSubscription = router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.getCategories();
            }
        });
        if(window.location.href.includes("categories")){
          this.categoriesPage=true;
        }
        else{ 
            this.categoriesPage=false;
        }
    }

  ngOnChanges(): void {
  }

  ngAfterViewInit() {
    this.nameRouting.push({name_en: 'categories', name_ar: 'الفئات'})
              this.homeData.categoriesDataSub.subscribe((data) => {
              if(data.length > 0){
                  this.allCategories = data ;
                  this.getCategories();
          }
        });

   
        this.CateSwiperConfig = {
            slidesPerView: 7,
            spaceBetween: 16,
              keyboard: true,
            navigation: true,
            pagination: false,
            grabCursor: true,
            loop: true,
            preloadImages: false,
            lazy: true,
            rtl:true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            speed: 500,
            effect: "slide",
            breakpoints: {
                320: {
                    slidesPerView: 2,
                },
                480: {
                    slidesPerView: 2,
                },
                600: {
                    slidesPerView: 3,
                },
                960: {
                    slidesPerView: 4,
                },
                992: {
                    slidesPerView: 6,
                },
                1280: {
                    slidesPerView: 6,
                },
                1500: {
                    slidesPerView: 6,
                },
            },
        };
    }
  
    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            this.categoryTypeData.isSlider = this.environmentVariables.CATEGORY_STYLE;
            this.categoryTypeData.isSqure = this.environmentVariables.CATEGORY_CARD;
        });
    }


    rediectToProductPage(item:any){
      if(this.environmentVariables.MENU_LINK_TYPE === 'slug'){
            if(this.environmentVariables?.ENABLE_CATEGORY_VIEW){
                this.router.navigate([this.lang + "/category/" + item.slug])
            }else{
                this.router.navigate([this.lang + '/product/' + item.slug]);
            }
      }
      else{
        this.router.navigate(["/" + this.lang + (this.environmentVariables?.ENABLE_CATEGORY_VIEW ? "/category": "/products")], {
                    queryParams: {
                        category_id: item.id,
                        category_name:
                            this.lang == "ar" &&
                            item.name_ar
                                ? item.name_ar
                                : item.name
                    },
                });
      }
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.firstTimeLoaded = false;
        }, 1000);
    }

    ngOnDestroy() {
        this.routerSubscription.unsubscribe();
    }

    getCategories() {
        if(this.allCategories.length){
            this.allFeaturedCategories = this.allCategories.filter(x=>x.featured);
            if(this.allFeaturedCategories.length == 0){
                let x = document.getElementById('view-all-categories')!;
                if(x){
                    x.style.display = 'none';
                }
            }
            else {
                let x = document.getElementById('view-all-categories')!;
                if(x){
                    x.style.display = 'flex';
                }
            }
        }
    }
}
